<div class="gonvarri-chapa" *ngIf="productType !== ''">

  <div *ngIf="productType.includes('productType_sheet')">
    <p class="gonvarri-chapa__title" *ngIf="!hideTexts">{{'gonvarri.chapa.quantity.title' | cxTranslate}}</p>
    <div  class="gonvarri-chapa__holder">
      <input type="number"
        class="gonvarri-chapa-quantity__holder__input"
        [(ngModel)]="numberOfSheets"
        (ngModelChange)="updateValuesNumber()"
        #numberOfSheetsController
      />
      <p class="gonvarri-chapa__holder__warning" *ngIf="!hideTexts">
        {{'gonvarri.chapa.quantity.warning' | cxTranslate}} {{ceilTotalKg(numberOfSheets * KG_EACH)}}Kg
      </p>
    </div>
    <sub class="gonvarri-chapa__subtext" *ngIf="(ceilTotalKg(numberOfSheets * KG_EACH) < MIN_KG) && !hideTexts">
      {{'gonvarri.chapa.quantity.minText' | cxTranslate}}: {{MIN_KG}}Kg
    </sub>
    <sub class="gonvarri-chapa__subtext" *ngIf="(ceilTotalKg(numberOfSheets * KG_EACH) > MAX_KG) && !hideTexts">
      {{'gonvarri.chapa.quantity.maxText' | cxTranslate}}: {{MAX_KG}}Kg
    </sub>
  </div>

  <div *ngIf="productType.includes('productType_raw')">
    <p class="gonvarri-chapa__title" *ngIf="!hideTexts">{{'gonvarri.chapa.raw.title' | cxTranslate}}</p>
    <div  class="gonvarri-chapa__holder">
      <input type="number"
        class="gonvarri-chapa-raw__holder__input"
        [(ngModel)]="packageWeigth"
        (ngModelChange)="updateValuesPackage()"
        #packageWeightController
      />
    </div>
    <sub class="gonvarri-chapa__subtext" *ngIf="((packageWeigth) < MIN_KG) && !hideTexts">
      {{'gonvarri.chapa.raw.minText' | cxTranslate}}: {{MIN_KG}}Kg
    </sub>
    <sub class="gonvarri-chapa__subtext" *ngIf="((packageWeigth) > MAX_KG) && !hideTexts">
      {{'gonvarri.chapa.raw.maxText' | cxTranslate}}: {{MAX_KG}}Kg
    </sub>
  </div>

  <div *ngIf="!productType.includes('productType_sheet') && !productType.includes('productType_raw')">
    <p class="gonvarri-chapa__title" *ngIf="!hideTexts">{{'gonvarri.chapa.raw.title' | cxTranslate}}</p>
    <div  class="gonvarri-chapa__holder">
      <input type="number"
        class="gonvarri-chapa-raw__holder__input"
        disabled
        [value]="getValueCategory()"
      />
    </div>
  </div>

</div>
